export const blue = "#E2E3E5";
export const blueTranslucent = "rgba(0, 175, 235, 0.2)";
export const grey = "#d9d9d9";
export const transparent = "rgba(255, 255, 255, 0)";
export const redTranslucent = 'rgba(255, 99, 132, 0.3)';
export const red = '#EF5350';
export const greyShade = "#434F59";
export const modalGreyShade = "#E2E3E5 !important";
export const blueShade = "#4fb1ec";
export const white = "#FFFFFF";
export const black = "#000000";
export const green = "#92d050";
export const amber = "#ffbf00";


// WEBPACK FOOTER //
// ./styles/colorCharts.js